import React from 'react';
import { string, number, shape, array } from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import getSlug from 'speakingurl';
import ReactHtmlParser from 'react-html-parser';

// Import styles
import {
	Item,
	Content,
	HeadingThirdStyled,
	Paragraph,
	LinkStyled
} from './styles';

// Import helpers
import { getImage } from 'helpers';

// Import utilities
import { useUserSourceType } from 'components/utilities';

// Import variables
import { PRODUCT_IMAGES_TYPES } from 'helpers/variables';
import { URL_CONFIGURATOR } from 'components/views/configurator/helpers';

const { COVER_LARGE } = PRODUCT_IMAGES_TYPES;

const Packet = ({ width, height, title, description, uuid, type, images }) => {
	const { t } = useTranslation();
	const { isNexGenUser } = useUserSourceType();

	const slugTitle = getSlug(title);

	const isCollection = type === 'collection';
	const pathName = isCollection
		? `/vod/kolekcje/${uuid}/${slugTitle}`
		: isNexGenUser
		? URL_CONFIGURATOR
		: `/pakiety/pakiet/${uuid}/${slugTitle}`;

	const packetImage = getImage({ images, types: [COVER_LARGE] });

	return (
		<Item
			rel="noopener noreferrer"
			image={packetImage}
			width={width}
			height={height}
		>
			<Content>
				{title && <HeadingThirdStyled>{title}</HeadingThirdStyled>}
				{description && (
					<Paragraph lineHeight={21}>{ReactHtmlParser(description)}</Paragraph>
				)}
				<LinkStyled
					as={Link}
					to={pathName}
					type="submit"
					modifiers={['primaryVod']}
				>
					{t('packets_slider_btn_show')}
				</LinkStyled>
			</Content>
		</Item>
	);
};

Packet.propTypes = {
	width: number.isRequired,
	height: number.isRequired,
	title: string,
	description: string,
	uuid: string.isRequired,
	type: string.isRequired,
	images: shape({
		cover: array,
		cover_large: array
	})
};

export default Packet;
